<form *ngIf="!autoLogin && visible" id="login" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div id="login-container">
    <img src="./assets/img/logo_login.png">
    <div id="login-content">
      <h5>{{ "login" | language }}</h5>
      <h6 *ngIf="!desk && showSelectOffice">{{ "selectOffice" | language }}</h6>
      <select (change)="changeOffice()" *ngIf="!desk && showSelectOffice" [(ngModel)]="office" [ngModelOptions]="{standalone: true}"
        class="form-control">
        <option value="" disabled selected>{{ "selectOffice" | language }}</option>
        <ng-container *ngIf="config.showofficeid">
          <option *ngFor="let o of offices" [value]="o.id">#{{ o.id }} - {{ o.name }}</option>
        </ng-container>
        <ng-container *ngIf="!config.showofficeid">
          <option *ngFor="let o of offices" [value]="o.id">{{ o.name }}</option>
        </ng-container>

      </select>
      <select *ngIf="!desk && office" formControlName="desk" class="form-control">
        <option value="" disabled selected>{{ "selectDesk" | language }}</option>
        <ng-container *ngIf="config.showdeskid">
          <option *ngFor="let d of desks" [value]="d.id">#{{ d.id }} - {{ d.title }}</option>
        </ng-container>
        <ng-container *ngIf="!config.showdeskid">
          <option *ngFor="let d of desks" [value]="d.id">{{ d.title }}</option>
        </ng-container>
      </select>
      <hr>
      <input type="text" formControlName="user" [placeholder]="'user' | language" class="form-control">
      <input type="password" formControlName="password" [placeholder]="'pass' | language" class="form-control">
      <div *ngIf="hasError && (errorStatus == 422 || errorStatus == 400)" class="alert alert-danger" role="alert">
        <span *ngIf="errorStatus != 422">{{ "incorrect" | language }}</span>
        <span *ngIf="errorStatus == 422">{{ "deskInUse" | language }}</span>
      </div>
      <div *ngIf="hasError && errorStatus == 403" class="alert alert-danger" role="alert">
        <span>{{ "forbidden" | language }}</span>
      </div>
      <div *ngIf="hasError && errorStatus == 428" class="alert alert-danger" role="alert">
        <span>{{ "nodeskprofile" | language }}</span>
      </div>
      <button type="submit" class="btn btn-success" [disabled]="!loginForm.valid">{{ "join" | language }}</button>
      <div *ngIf="config && config.changepassword" class="text-center mt-4 text-primary cursor-pointer" (click)="openChangePasswordModal()">{{ "changePassword" | language }}</div>
    </div>
  </div>
</form>


<div *ngIf="autoLogin && visible">
  <div class="card text-white bg-dark mb-3 mt-4 mr-auto ml-auto" style="max-width: 18rem;">
    <div class="card-body text-center">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw text-light"></i>
    </div>
  </div>
</div>

<app-modal [id]="'changePasswordModal'" [dragable]="false" [resizable]="false">
  <span modal-title>{{ "changePassword" | language }}</span>
  <div modal-body>
    <div [class]="repeatPasswordAlertClass" *ngIf="repeatPasswordAlert">{{ repeatPasswordAlertText }}</div>

    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
      <div class="form-group">
        <label>{{ "user" | language }}</label>
        <input type="text" class="form-control" formControlName="user"
        [ngClass]="{'is-invalid':changePasswordForm.controls.user.invalid && (changePasswordForm.controls.user.dirty || changePasswordForm.controls.user.touched), 'is-valid':changePasswordForm.controls.user.valid && (changePasswordForm.controls.user.dirty || changePasswordForm.controls.user.touched)}">
        <div *ngIf="changePasswordForm.controls.user.invalid && (changePasswordForm.controls.user.dirty || changePasswordForm.controls.user.touched)"
                class="invalid-feedback"> {{ "enterUser" | language }}</div>
      </div>
      <div class="form-group">
        <label>{{ "actualPassword" | language }}</label>
        <input type="password" class="form-control" formControlName="lastPassword"
        [ngClass]="{'is-invalid':changePasswordForm.controls.lastPassword.invalid && (changePasswordForm.controls.lastPassword.dirty || changePasswordForm.controls.lastPassword.touched), 'is-valid':changePasswordForm.controls.lastPassword.valid && (changePasswordForm.controls.lastPassword.dirty || changePasswordForm.controls.lastPassword.touched)}">
        <div *ngIf="changePasswordForm.controls.lastPassword.invalid && (changePasswordForm.controls.lastPassword.dirty || changePasswordForm.controls.lastPassword.touched)"
                class="invalid-feedback"> {{ "enterActualPassword" | language }}</div>
      </div>
      <hr>
      <div class="form-group">
        <label>{{ "newPassword" | language }}</label>
        <input type="password" class="form-control" formControlName="newPassword"
        [ngClass]="{'is-invalid':changePasswordForm.controls.newPassword.invalid && (changePasswordForm.controls.newPassword.dirty || changePasswordForm.controls.newPassword.touched), 'is-valid':changePasswordForm.controls.newPassword.valid && (changePasswordForm.controls.newPassword.dirty || changePasswordForm.controls.newPassword.touched)}">
        <div *ngIf="changePasswordForm.controls.newPassword.invalid && (changePasswordForm.controls.newPassword.dirty || changePasswordForm.controls.newPassword.touched)"
                class="invalid-feedback"> {{ "enterNewPassword" | language }}</div>
      </div>
      <div class="form-group">
        <label>{{ "repeatPassword" | language }}</label>
        <input type="password" class="form-control" formControlName="repeatNewPassword"
        [ngClass]="{'is-invalid':changePasswordForm.controls.repeatNewPassword.invalid && (changePasswordForm.controls.repeatNewPassword.dirty || changePasswordForm.controls.repeatNewPassword.touched), 'is-valid':changePasswordForm.controls.repeatNewPassword.valid && (changePasswordForm.controls.repeatNewPassword.dirty || changePasswordForm.controls.repeatNewPassword.touched)}">
        <div *ngIf="changePasswordForm.controls.repeatNewPassword.invalid && (changePasswordForm.controls.repeatNewPassword.dirty || changePasswordForm.controls.repeatNewPassword.touched)"
                class="invalid-feedback"> {{ "repeatPassword" | language }}</div>
      </div>
      <button type="submit" class="btn btn-success float-right" [disabled]="changePasswordForm.invalid">{{ "accept" | language }}</button>
    </form>
  </div>
</app-modal>

<app-modal [id]="'deskInUseModal'" [dragable]="false" [resizable]="false">
  <span modal-title>El puesto de atención ya está en uso</span>
  <div modal-body>
    ¡Atención! El puesto de atención <b>{{onlineDeskName}}</b> de la oficina <b>{{onlineOfficeName}}</b> ya está en uso por el usuario con
    dirección IP <b>{{onlineDeskIP}}</b><br><br>¿Realmente desea continuar? Se cerrará la sesión
    del usuario que esté utilizándolo actualmente.<br><br>

    <input [(ngModel)]="disconectSessionConfirm" id="disconectSessionConfirm" type="checkbox"> <label for="disconectSessionConfirm"> Entendido, quiero conectarme igualmente.</label>
    <br><br>
    <button (click)="doLogin(lastCredentials, false, false)" class="btn btn-success" [disabled]="!disconectSessionConfirm">Aceptar y continuar</button>
    <button (click)="resetLogin()" class="btn btn-danger ml-2">Cancelar</button>
  </div>
</app-modal>
